
export const intervals = {
    T1: { i: 0, r: 0 },
    s2: { i: 0, r: 1 },
    B1: { i: 1, r: 0 },
    k2: { i: 1, r: 1 },
    N2: { i: 2, r: 1 },
    s3: { i: 2, r: 2 },
    B2: { i: 3, r: 1 },
    k3: { i: 3, r: 2 },
    N3: { i: 4, r: 2 },
    B3: { i: 5, r: 2 },
    s4: { i: 4, r: 3 },
    T4: { i: 5, r: 3 },
    B4: { i: 6, r: 3 },
    s5: { i: 6, r: 4 },
    T5: { i: 7, r: 4 },
    B5: { i: 8, r: 4 },
    k6: { i: 8, r: 5 },
    N6: { i: 9, r: 5 },
    s7: { i: 9, r: 6 },
    B6: { i: 10, r: 5 },
    k7: { i: 10, r: 6 },
    N7: { i: 11, r: 6 },
    s8: { i: 11, r: 7 },
    T8: { i: 12, r: 7 },
    B8: { i: 13, r: 7 },
    k9: { i: 13, r: 8 },
    N9: { i: 14, r: 8 },
    k10: { i: 15, r: 9 },
    N10: { i: 16, r: 9 },
    T11: { i: 17, r: 10 },
    B11: { i: 18, r: 10 },
    s12: { i: 18, r: 11 },
    "T8+T5": { i: 19, r: 11 },
    "T8+B5": { i: 20, r: 11 },
    "T8+k6": { i: 20, r: 12 },
    "T8+N6": { i: 21, r: 12 },
    "T8+B6": { i: 22, r: 12 },
    "T8+k7": { i: 22, r: 13 },
    "T8+N7": { i: 23, r: 13 },
    "T8+s8": { i: 23, r: 14 },
    "T8+T8": { i: 24, r: 14 },
    "T8+T8+k2": { i: 25, r: 15 },
    "T8+T8+N2": { i: 26, r: 15 },
    "T8+T8+k3": { i: 27, r: 16 },
};

export const decodeIntervalToEn = (label: string) => {
    label = label.replace(/T/g, "P");
    label = label.replace(/s/g, "d");
    label = label.replace(/B/g, "A");
    label = label.replace(/N/g, "M");
    label = label.replace(/k/g, "m");
    return label;
};

export const decodeIntervalToIt = (label: string) => {
    const with2Octaves = label.indexOf("T8+T8+") === 0;
    const with1Octave = !with2Octaves && label.indexOf("T8+") === 0;
    if (with2Octaves) label = label.slice(6);
    if (with1Octave) label = label.slice(3);
    if (label.length === 3){
        label = label.slice(1, 3) + label.slice(0, 1);
    } else {
        label = label.slice(1) + label.slice(0, 1);
    }
    label = label.replace(/T/g, "G");
    label = label.replace(/s/g, "dim");
    label = label.replace(/B/g, "ecc");
    label = label.replace(/N/g, "M");
    label = label.replace(/k/g, "m");
    if (with2Octaves) label = "8G+8G+" + label;
    if (with1Octave) label = "8G+" + label;
    return label;
};

export const decodeIntervalToEs = (label: string) => {
    const with2Octaves = label.indexOf("T8+T8+") === 0;
    const with1Octave = !with2Octaves && label.indexOf("T8+") === 0;
    if (with2Octaves) label = label.slice(6);
    if (with1Octave) label = label.slice(3);
    if (label !== "10") {
        label = label.slice(1) + label.slice(0, 1);
    }
    label = label.replace(/T/g, "J");
    label = label.replace(/s/g, "dis");
    label = label.replace(/B/g, "A");
    label = label.replace(/N/g, "M");
    label = label.replace(/k/g, "m");
    if (with2Octaves) label = "8J+8J+" + label;
    if (with1Octave) label = "8J+" + label;
    return label;
};

export const decodeIntervalToLt = (label: string) => {
    label = label.replace(/T/g, "gr.");
    label = label.replace(/s/g, "sum.");
    label = label.replace(/B/g, "pad.");
    label = label.replace(/N/g, "d.");
    label = label.replace(/k/g, "m.");
    return label;
};

export const decodeIntervalToEt = (label: string) => {
    label = label.replace(/T/g, "p ");
    label = label.replace(/s/g, "> ");
    label = label.replace(/B/g, "< ");
    label = label.replace(/N/g, "s ");
    label = label.replace(/k/g, "v ");
    label = label.replace(/\+/g, " + ");
    return label;
};

export const decodeIntervalToHr = (label: string) => {
    label = label.replace(/T/g, "Č");
    label = label.replace(/s/g, "sm");
    label = label.replace(/B/g, "Pov");
    label = label.replace(/N/g, "V");
    label = label.replace(/k/g, "m");
    return label;
};

export const decodeIntervalToNl = (label: string) => {
    label = label.replace(/T/g, "R");
    label = label.replace(/s/g, "v");
    label = label.replace(/B/g, "O");
    label = label.replace(/N/g, "G");
    label = label.replace(/k/g, "k");
    return label;
};

export const decodeIntervalToEl = (label: string) => {
    const with2Octaves = label.indexOf("T8+T8+") === 0;
    const with1Octave = !with2Octaves && label.indexOf("T8+") === 0;
    if (with2Octaves) label = label.slice(6);
    if (with1Octave) label = label.slice(3);
    if (label.length === 3){
        label = label.slice(1, 3) + label.slice(0, 1);
    } else {
        label = label.slice(1) + label.slice(0, 1);
    }
    label = label.replace(/T/g, "K");
    label = label.replace(/s/g, "E")
    label = label.replace(/B/g, "A");
    label = label.replace(/N/g, "M");
    label = label.replace(/k/g, "μ");
    if (with2Octaves) label = "8K+8K+" + label;
    if (with1Octave) label = "8K+" + label;
    return label;
}

export const decodeIntervalToGa = (label: string) => {
    if (label !== "10") {
        if (label.length === 2) {
            label = label.slice(1, 2) + label.slice(0, 1);
        } else if (label.length === 3) {
            label = label.slice(1, 3) + label.slice(0, 1);
        } else if (label.length === 5) {
            label = label.slice(1, 2) + label.slice(0, 1) + "+" + label.slice(4, 5) + label.slice(3, 4);
        } else if (label.length === 8) {
            label =
                label.slice(1, 2) +
                label.slice(0, 1) +
                "+" +
                label.slice(4, 5) +
                label.slice(3, 4) +
                "+" +
                label.slice(7, 8) +
                label.slice(6, 7);
        }
    }
    label = label.replace(/T/g, "F");
    label = label.replace(/s/g, "l");
    label = label.replace(/B/g, "Mh");
    label = label.replace(/N/g, "M");
    label = label.replace(/k/g, "m");
    return label;
};

const plIntervals: {[interval: string]: string} = {
    T1: "1",
    s2: "2>>",
    B1: "1<",
    k2: "2>",
    N2: "2",
    s3: "3>",
    B2: "2<",
    k3: "3m",
    N3: "3w",
    s4: "4>",
    T4: "4",
    B4: "4<",
    s5: "5>",
    T5: "5",
    B5: "5<",
    k6: "6>",
    N6: "6",
    s7: "7>",
    B6: "6<",
    k7: "7",
    N7: "7<",
    s8: "8>",
    T8: "8",
    B8: "8<",
    k9: "9>",
    N9: "9",
    k10: "10>",
    N10: "10",
    T11: "11",
    B11: "11<",
    s12: "12>",
    "T8+T5": "8+5",
    "T8+B5": "8+5<",
    "T8+k6": "8+6>",
    "T8+N6": "8+6",
    "T8+B6": "8+6<",
    "T8+k7": "8+7",
    "T8+N7": "8+7<",
    "T8+s8": "8+8>",
    "T8+T8": "8+8",
    "T8+T8+k2": "8+8+2>",
    "T8+T8+N2": "8+8+2",
    "T8+T8+k3": "8+8+3m",
};
const decodeIntervalToPl = (label: string) => {
    return plIntervals[label] || label;
};

export const localizeInterval = (label: string, locale: string) => {
    switch (locale) {
        case "hu":
            return label;
        case "hr":
            return decodeIntervalToHr(label);
        case "et":
            return decodeIntervalToEt(label);
        case "ga":
            return decodeIntervalToGa(label);
        case "lt":
            return decodeIntervalToLt(label);
        case "pl":
            return decodeIntervalToPl(label);
        case "it":
            return decodeIntervalToIt(label);
        case "es":
        case "ca":
            return decodeIntervalToEs(label);
        case "el":
            return decodeIntervalToEl(label);
        case "nl":
            return decodeIntervalToNl(label);
        default:
            return decodeIntervalToEn(label);
    }
};

export const intervalOptions = (locale: string) =>
    Object.keys(intervals).map(interval => {
        return {
            value: interval,
            label: localizeInterval(interval, locale),
        };
    });